export default {
  list: { lazy: () => import('./GlobalUsers'), component: 'GlobalUserList' },
  edit: { lazy: () => import('./GlobalUsers'), component: 'GlobalUserEdit' },
}
